import React from "react";
import {stack as Menu} from "react-burger-menu";
import classes from "./BurgerMenu.module.css"
import {ReactComponent as TeamFerrets} from "./assets/teamferrets_logo.svg"
import TwitterLogo from "./assets/logo-black.png"

type Props = {
    pageWrapId: string
    outerContainerId: string
    setIsPrivacyPolicyModal: React.Dispatch<React.SetStateAction<boolean>>
    setIsTermsOfUseModal: React.Dispatch<React.SetStateAction<boolean>>

}

export const BurgerMenu = (props: Props) => {

    const isSmartPhone = () => {
        if (navigator.userAgent.match(/iPhone|Android.+Mobile/)) {
            return true;
        } else {
            return false;
        }
    };

    const styles = {
        bmBurgerButton: {
            position: 'absolute',
            width: '36px',
            height: '30px',
            right: '10px',
            top: '18px'
        },
        bmBurgerBars: {
            // background: '#373a47'
            background: '#ffffff',
            border: "1px solid darkgreen"
        },
        bmBurgerBarsHover: {
            background: '#a90000'
        },
        bmCrossButton: {
            height: '24px',
            width: '24px'
        },
        bmCross: {
            background: '#bdc3c7'
        },
        bmMenuWrap: {
            position: 'fixed',
            height: '100%'
        },
        bmMenu: {
            background: '#373a47',
            padding: '2.5em 1.5em 0',
            fontSize: '1.15em'
        },
        bmMorphShape: {
            fill: '#373a47'
        },
        bmItemList: {
            color: '#b8b7ad',
            padding: '0.8em',
            height: '90%',
            display: 'flex',
            flexDirection: 'column',
            gap: '5px',
            justifyContent: "space-between"
        },
        bmItem: {
        },
        bmOverlay: {
            background: 'rgba(0, 0, 0, 0.3)'
        }
    }

    const smartPhoneStyles = {
        bmBurgerButton: {
            position: 'fixed',
            width: '36px',
            height: '30px',
            right: '18px',
            top: '18px'
        },
        bmBurgerBars: {
            // background: '#373a47'
            background: '#ffffff',
            border: "1px solid darkgreen"
        },
        bmBurgerBarsHover: {
            background: '#a90000'
        },
        bmCrossButton: {
            height: '24px',
            width: '24px'
        },
        bmCross: {
            background: '#bdc3c7'
        },
        bmMenuWrap: {
            position: 'fixed',
            height: '100%',
            width: '180px',
        },
        bmMenu: {
            background: '#373a47',
            padding: '2.5em 10px 0',
            fontSize: '16px',
        },
        bmMorphShape: {
            fill: '#373a47'
        },
        bmItemList: {
            color: '#b8b7ad',
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            gap: '5px',
            justifyContent: "space-between"
        },
        bmItem: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
        },
        bmOverlay: {
            background: 'rgba(0, 0, 0, 0.3)'
        }
    }

    const twitText = () => {
        const text = "黒って300色あんねん！探してみー！%0A"
        const tag = "black300,TeamFerrets"
        const url = "https://black-300.com%0A%0A";

        if (text.length > 140) {
            alert("テキストが140字を超えています");
        } else {
            const apiUrl = `http://twitter.com/intent/tweet?url=${url}&hashtags=${tag}&text=${text}`
            return apiUrl
        }
    }
    return (
        <Menu pageWrapId={props.pageWrapId} outerContainerId={props.outerContainerId} itemListElement="div" right
              styles={isSmartPhone() ? smartPhoneStyles : styles}>
            <div className={classes.infoArea}>
                <div className={classes.privacyPolicy}
                     onClick={() => props.setIsPrivacyPolicyModal(true)}>プライバシーポリシー
                </div>
                <div className={classes.termsOfUse} onClick={() => props.setIsTermsOfUseModal(true)}>利用規約</div>
                <div className={classes.inquiries} onClick={() => window.open("https://team-ferrets.com/contact")}>お問い合わせ</div>
            </div>
            <div className={classes.logoArea} onClick={() => window.open("https://team-ferrets.com", "_blank")}>
                {isSmartPhone()
                    && <button className={classes.twitterButton} onClick={()=>window.open(twitText(),"_blank")}>
                        <img src={TwitterLogo} alt="Xでポストする"></img>
                        <span>ポスト</span>
                    </button>
                }
                <p className={classes.logoText}>created by</p>
                <TeamFerrets className={classes.teamFerretsLogo}/>
            </div>
        </Menu>
    );
};

